import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { MagnifyingGlassPlusSVG } from '@common_components/svg/magnifyingGlassPlus.svg';

const MagnifyingGlassPlusIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <MagnifyingGlassPlusSVG/>
    </div>
  );
};

export { MagnifyingGlassPlusIcon };
